export default {
  title: 'Toimituspalvelut',
};
